import React from 'react'
import Modal from 'react-modal';
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css';
import '../../css/react-datepicker.css';
import { insertHoliday } from '../../actions/employeeActions'
import { updateHoliday } from '../../actions/employeeActions'
import moment from 'moment';



class AddHolidayModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.holidayItem.length == 0 ? '0' : '1',
            holidayDate: this.props.holidayItem.length == 0 ? '' : new Date(this.props.holidayItem[0].HolidayDate),
            name: this.props.holidayItem.length == 0 ? '' : this.props.holidayItem[0].Name,
            remark: this.props.holidayItem.length == 0 ? '' : this.props.holidayItem[0].Remark == null ? '' : this.props.holidayItem[0].Remark,
            errors: {}
        }
        this.toggleModal = this.toggleModal.bind(this);
        this._onChange = this._onChange.bind(this);
        this.handleValidation = this.handleValidation.bind(this)
    }
    _onChange(seletedDate) {
        this.setState({
            holidayDate: seletedDate
        })
    }
    toggleModal() {
        this.props.toggle();
    }

    handleSubmit = async (event) => {
        event.preventDefault()
        if (this.handleValidation()) {
            if (this.state.id == '0') {
                this.state.holidayDate = new Date(moment(this.state.holidayDate).format('YYYY-MM-DD'))
                await insertHoliday(this.state);
            }
            else if (this.state.id == '1') {
                this.state.holidayDate = new Date(moment(this.state.holidayDate).format('YYYY-MM-DD'))
                await updateHoliday(this.state);
            }
            this.props.refreshData();
            this.toggleModal()
        }
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
        })
    }

    handleValidation() {
        let formIsValid = true;
        let errors = {};
        if (!this.state.holidayDate) {
            formIsValid = false;
            errors["holidayDate"] = "Holiday Date is required."
        }
        if (!this.state.name) {
            formIsValid = false;
            errors["name"] = "Name is required.";
        }
        this.setState({ errors: errors });
        return formIsValid
    }

    render() {
        return (
            <>
                <Modal isOpen={this.props.isOpen} onAfterOpen={this.afterOpenModal} onRequestClose={this.toggleModal} ariaHideApp={false} className='modal-style' contentLabel="">
                    <div id='addHolidayModal' className={'ir-modal-blue-header'}>
                        <div className={'modal fade-in'} style={{ display: 'block' }}>
                            <div className={'modal-dialog wd400'}>
                                <form onSubmit={this.handleSubmit}>
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <div className="title">Add Holiday</div>
                                            <div className='inline-block right pdT9'>
                                                <span id='spnCancel' onClick={() => { this.props.toggle(); }}>
                                                    <i className="fas fa-times"></i>
                                                </span>
                                            </div>                                    </div>
                                        <div className='modal-body'>
                                            <div>
                                                <label className="control-label">Holiday Date</label>
                                                <DatePicker className='form-control' selected={this.state.holidayDate}
                                                    onChange={this._onChange}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    placeholderText="MM/DD/YYYY" />
                                                <span style={{ color: "red" }}>{this.state.errors["holidayDate"]}</span>
                                            </div>
                                            <div>
                                                <label className="control-label">Name</label>
                                                <input type='text' id="txtName" name="name" placeholder='Name' onChange={this.handleChange} value={this.state.name} className="form-control" />
                                                <span style={{ color: "red" }}>{this.state.errors["name"]}</span>
                                            </div>
                                            <div>
                                                <label className="control-label">Remarks</label>
                                                <textarea rows="5" id="txtRemark" name="remark" onChange={this.handleChange} value={this.state.remark} className="form-control"></textarea>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button type="submit" className="btn btn-success" id="addHoliday">Add</button>
                                            <button type="button" id="btnCancelDialog" className="btn btn-default" onClick={() => { this.props.toggle(); }} >Cancel</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </Modal>
            </>
        )
    }
}
export default AddHolidayModal
